import { useHead, useSiteConfig } from '#imports'

export default defineNuxtPlugin(() => {
  const site = useSiteConfig()

  useHead(() => ({
    script: [
      {
        key: 'schema-site',
        type: 'application/ld+json',
        children: JSON.stringify([
          {
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: site.name || 'Kudo Sales',
            url: site.url,
          },
          {
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: site.name || 'Kudo Sales',
            url: site.url,
            description: site.description,
          },
        ]),
      },
    ],
  }))
})
